import {TableDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';


const tableDefinition : TableDefinition = {
    table   : 'CI_VALUE',
    fieldMap: {
        id              : 'CIV_ID',
        statusId        : 'CIV_CIST_ID',
        origin          : 'CIV_ORIGIN',
        module          : 'CIV_MODULE',
        valueSetId      : 'CIV_CIVS_ID',
        value           : 'CIV_VALUE',
        label           : 'CIV_LABEL',
        sortOrder       : 'CIV_SORTORDER',
        modifierUserId  : 'CIV_MODIFIER',
        modificationTime: 'CIV_MODIFICATION_TIME',
        uuid            : 'CIV_UUID'
    }
};

export default tableDefinition;
